import React, { useEffect, useState } from 'react'
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router';
import { CampaignGet } from '../../../api/orgService';
import useApi from '../../../api/useApi';
import { toast } from 'react-toastify';
import SkeletonList from '../../sections/SkeletonList';

function CampaignAdminList() {
    const navigate = useNavigate()
    const { request: getAllCampaigns, data:campaignData, error:campaignError, isLoading: campaignIsLoading} = useApi(CampaignGet);
    const [allCampaigns,setAllCampaigns]=useState([])
    
              useEffect(() => {
                getAllCampaigns();
                     // eslint-disable-next-line
                }, []);
                
                useEffect(()=>{
                  if (campaignData?.status===200) {
                    setAllCampaigns(campaignData?.data?.results);
                  }
                // eslint-disable-next-line
                },[campaignData])
        
              
                // useEffect(()=>{
                //     if(location?.state?.refresh==="org"){
                //       getAllCampaigns();
                //     }
                //   // eslint-disable-next-line
                //   },[location?.state])
              
                useEffect(()=>{
                    if(campaignError){
                        toast.error(`${JSON.stringify(campaignError?.response?.data,null,2)}`,{position: "top-center"});
                  }
                },[campaignError]) 


    const rows = [
        { id: 1, title: 'Project Test', description: 'the Community version', link: "/staff/campaign/detail"},
        { id: 2, title: 'Data Grid Pro', description: 'the Pro version', link: "/staff/campaign/detail?id=1" },
        { id: 3, title: 'Data Grid Premium', description: 'the Premium version', link: "/staff/campaign/detail?id=1" },
      ];
      
    const columns = [
        { field: 'id', headerName: 'Campaign Number', width: 200 },
        { field: 'title', headerName: 'Campaign Name', width: 200 },
        { field: 'description', headerName: 'Campaign Description', width: 300 },
        { field: 'link', headerName: 'View Details', width: 300,
            renderCell: (params) => (
                // <Link
                //   href={params.value}
                //   style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
                // >
                //   View details →
                // </Link>
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => navigate(`/staff/campaign/detail/${params.row.id}/`, {state: { campaignId: params.row.id, campaignName: params.row.title}})}
                    sx={{
                    textTransform: 'none',
                    backgroundColor: '#1976d2',
                    '&:hover': { backgroundColor: '#115293' },
                    }}
                >
                    View Details →
                </Button>
              ),
         }
    
      ];
    
  if(campaignIsLoading){
        return (
          <SkeletonList/>
        )
      }
  return (
    <div style={{ height: '80%', width: '100%' }}>
      <DataGrid rows={allCampaigns} columns={columns} />
    </div>
  )
}

export default CampaignAdminList